import { render } from "./InactiveScreen.vue?vue&type=template&id=17b5ec89&scoped=true"
import script from "./InactiveScreen.vue?vue&type=script&lang=js"
export * from "./InactiveScreen.vue?vue&type=script&lang=js"

import "./InactiveScreen.vue?vue&type=style&index=0&id=17b5ec89&scoped=true&lang=css"

import exportComponent from "/Users/peterdevos/Sites/multiple_choice_aethon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b5ec89"]])

export default __exports__